<template>
  <div class="timeline-scroll-wrapper" v-if="schemeRating.length">
    <div class="d-flex align-items-center">
      <h5 class="me-2">Historical Ratings of the fund</h5>
      <img class="mb-2" src="@/assets/images/historical.svg" />
    </div>
    <div class="timeline-scroll-inner">
    <div class="timeline-align mt-5 mb-3">
      <Timeline
        :value="events"
        layout="horizontal"
        align="bottom"
        class="custom-timeline"
      >
        <template #content="slotProps">
          <div
            class="timeline-label text-center fw-bold"
            :class="{ 'first-item': slotProps.index === 0 }"
          >
            <div class="text-align-center font-size-responsive">
              {{ slotProps.item.rating }}
              <span class="star-outline">&#9734;</span>
            </div>
            <div class="timeline-date mt-1 font-size-date">
              {{ slotProps.item.date }}
            </div>
          </div>
        </template>
      </Timeline>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Timeline from 'primevue/timeline'

export default {
  components: {
    Timeline,
  },
  
  computed: {
    ...mapGetters(['schemeData']),
    schemeRating() {
      return this.schemeData?.schemeRating || []
    },
    events() {
  const latest = this.schemeRating.find(item => item.expiry_date === 'latest')
  const rest = this.schemeRating
    .filter(item => item.expiry_date !== 'latest')
    .sort((a, b) => new Date(b.expiry_date) - new Date(a.expiry_date)) // Sort descending

  const combined = latest ? [latest, ...rest] : rest

  return combined.map(item => {
    const isLatest = item.expiry_date === 'latest'
    const date = isLatest ? 'Latest' : new Date(item.expiry_date)
    const formattedDate = isLatest
      ? 'Latest'
      : `${date.getFullYear()}-${date.toLocaleString('default', { month: 'short' })}`

    return {
      date: formattedDate,
      rating: item.rating,
    }
  })
  },
  },
}
</script>

<style scoped>

@media (max-width: 800px) {
  .timeline-scroll-inner {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
  }
}

.font-size-responsive {
  font-size: 14px;
}

.font-size-date {
  font-size: 12px;
}

@media (max-width: 800px) {
  .timeline-scroll-wrapper {
    white-space: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.star-outline {
  font-size: 18px;
  color: black;
}

.first-item {
  color: #0377a6;
}

::v-deep(
  .timeline-align
    .p-timeline
    .p-timeline-event
    .p-timeline-event-separator
    .p-timeline-event-marker
) {
  background: transparent !important;
}

::v-deep(
  .timeline-align
    .p-timeline
    .p-timeline-event
    .p-timeline-event-separator
    .p-timeline-event-connector
) {
  background: #80808057 !important;
}

@media (max-width: 768px) {
  ::v-deep(
    .custom-timeline .p-timeline-event .p-timeline-event-content .timeline-label
  ) {
    top: -36px !important;
    position: absolute !important;
    left: -12px !important;
  }
}

::v-deep(
  .custom-timeline .p-timeline-event .p-timeline-event-content .timeline-label
) {
  top: -32px;
  position: absolute;
  left: -14px;
}

::v-deep(.timeline-align .p-timeline-horizontal .p-timeline-event:last-child) {
  flex: 1;
}

::v-deep(.p-timeline-horizontal .p-timeline-event) {
  flex: 5;
}

@media (min-width: 768px) {
  ::v-deep(.p-timeline-horizontal .p-timeline-event) {
    flex: 2;
  }
}

.timeline-align {
  position: relative;
  top: 34px;
  left: 46px;
}
</style>
